import {
  FaBox,
  FaCalendarCheck,
  FaCarSide,
  FaCircleCheck,
  FaDatabase,
  FaGears,
  FaHouse,
  FaLayerGroup,
  FaListCheck,
  FaLocationDot,
  FaOilWell,
  FaSquareCaretRight,
  FaSquarePollVertical,
  FaStar,
  FaTriangleExclamation,
  FaTruck,
  FaTruckFront,
  FaUsers,
} from "react-icons/fa6";

const MenuSD2 = [
  {
    label: "Home",
    to: "",
    icon: <FaHouse />,
  },
  {
    label: "Operasional Mobil",
    type: "menu-title",
  },
  {
    label: "Jadwal Mobil",
    to: "transaksi/jadwal-mobil",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Cek Mobil",
    to: "transaksi/cek-keluar-masuk",
    icon: <FaListCheck />,
  },
  {
    label: "Problem Mobil",
    to: "problem/problem-kendaraan",
    icon: <FaGears />,
  },
  {
    label: "Warning Service",
    to: "service/warning-service",
    icon: <FaTriangleExclamation />,
  },
  {
    label: "Audit Mobil",
    to: "audit/audit-kendaraan",
    icon: <FaCarSide />,
  },
  {
    label: "Operasional Trado",
    type: "menu-title",
  },
  {
    label: "Jadwal Trado",
    to: "transaksi/jadwal-trado",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Cek Trado",
    to: "transaksi/cek-keluar-masuk-trado",
    icon: <FaListCheck />,
  },
  {
    label: "Problem Trado",
    to: "problem/problem-kendaraan-trado",
    icon: <FaGears />,
  },
  {
    label: "Audit Trado",
    to: "audit/audit-kendaraan-trado",
    icon: <FaTruckFront />,
  },
  {
    label: "Operasional Transport",
    type: "menu-title",
  },
  {
    label: "Pengisian Minyak",
    to: "transaksi/kendaraan-pengisian-minyak",
    icon: <FaOilWell />,
  },
  {
    label: "Kendaraan Retribusi",
    to: "transaksi/kendaraan-retribusi",
    icon: <FaListCheck />,
  },
  {
    label: "Laporan",
    type: "menu-title",
  },
  {
    label: "Laporan",
    to: "laporan",
    icon: <FaSquarePollVertical />,
  },
  {
    label: "Master & Setting",
    type: "menu-title",
  },
  {
    label: "Master - Transaksi",
    icon: <FaDatabase />,
    type: "menu-group",
    children: [
      {
        label: "Tujuan",
        to: "master/tujuan",
        icon: <FaLocationDot />,
      },
      {
        label: "Kendaraan",
        to: "master/kendaraan",
        icon: <FaTruck />,
      },
      {
        label: "Trailer",
        to: "master/trailer",
        icon: <FaBox />,
      },
      {
        label: "Kendaraan Grup",
        to: "master/kendaraan_grup",
        icon: <FaLayerGroup />,
      },
      {
        label: "Kendaraan Jenis",
        to: "master/kendaraan_jenis",
        icon: <FaStar />,
      },
      {
        label: "Jenis Mobil",
        to: "master/jenis-mobil",
        icon: <FaCarSide />,
      },
      {
        label: "Kendaraan Pemakaian",
        to: "master/kendaraan_pemakaian",
        icon: <FaSquareCaretRight />,
      },
      {
        label: "Opsi Pengecekan",
        to: "master/pengecekan_mobil_options",
        icon: <FaCircleCheck />,
      },
    ],
  },
  // {
  //   label: "Master - User",
  //   icon: <FaDatabase />,
  //   type: "menu-group",
  //   children: [
  //     {
  //       label: "Karyawan",
  //       to: "master/karyawan",
  //       icon: <FaUsers />,
  //     },
  //   ],
  // },
  {
    label: "Lain-Lain",
    type: "menu-title",
  },
];

export default MenuSD2;
